module.exports = __webpack_public_path__ + "static/media/submarine.8fad4ff9.png";